import { css } from 'lit';
import JhaStyleElement from '../../style-element/JhaStyleElement.js';
import { jhaStyles } from '../../styles/jha-styles.js';
/**
 * @element jha-slider
 */
export default class JhaSlider extends JhaStyleElement {
  static get styles() {
    return [
      jhaStyles,
      css`
        :host {
          display: block;
          overflow: hidden;
        }
      `,
    ];
  }
}
